import jQuery from "jquery";

/**
 * Add toggle functionality search form in the header.
 *
 * @export
 */
export default function() {
  const $ = jQuery;

  $(document).on("click", ".toggle-search", function() {
    $(".page__header").toggleClass("search--visible");
    $(".search-input").focus();
  });
}



// WEBPACK FOOTER //
// ./assets/src/js/components/search.js